import { render } from "./RequirementAttachmentCard.vue?vue&type=template&id=12a8f119&scoped=true"
import script from "./RequirementAttachmentCard.vue?vue&type=script&lang=js"
export * from "./RequirementAttachmentCard.vue?vue&type=script&lang=js"

import "./RequirementAttachmentCard.vue?vue&type=style&index=0&id=12a8f119&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-12a8f119"]])

export default __exports__